import React, { useEffect } from "react";
import moment from "moment";
import momentTz from "moment-timezone";
import { Select, Card, Radio } from "antd";
const { Option, OptGroup } = Select;

moment.locale("fr");
const BookingAvailabilitiesMobile = ({
  optionsPerDays,
  setOptionsPerDays,
  setSelectedSlot,
  selectedSlot,
  options,
  setOptions,
  amos,
  selectedAmo,
  setSelectedAmo,
  planning,
  rdv,
}) => {
  // const onTimeClick = (id, startDate) => {
  //   let slot = opts.filter((_) => _.booked === id)[0];
  //   setSelectedSlot({
  //     id,
  //     label: moment(startDate).format("ddd DD MMM YYYY HH:mm"),
  //     slot,
  //   });
  // };

  function handleChange(startDate) {
    // console.log(`selected ${value}`);
    // let slot = opts.filter((_) => _.booked === value)[0];
    // // console.log({
    // //   value,
    // //   label: moment(slot.start).format("ddd DD MMM YYYY HH:mm"),
    // //   slot,
    // // });
    // setSelectedSlot({
    //   value,
    //   label: moment(slot.start).format("ddd DD MMM YYYY HH:mm"),
    //   slot,
    // });

    // console.log(`startDate selected : ${startDate}`);
    // console.log(`OPTS ---> ${JSON.stringify(opts)}`);
    // let slot = options.find((_) => _.start === parseInt(startDate));

    let slot = undefined;
    if (planning.areAmosAssigned) {
      // console.log(`pass in and out`);
      // console.log(
      //   `planning.amoList.findIndex((e) => e === selectedAmo) : ${planning.amoList.findIndex(
      //     (e) => e === selectedAmo
      //   )}`
      // );
      // console.log(`options = ${JSON.stringify(options)}`);
      let selectedAmoNb = planning.amoList.findIndex((e) => e === selectedAmo);
      slot = options.find(
        (_) => _.start === parseInt(startDate) && _.amoNb === selectedAmoNb
      );
    } else {
      // console.log(`pass other`);
      slot = options.find((_) => _.start === parseInt(startDate));
      // console.log(`SLOTS --> ${JSON.stringify(slot)}`);
    }
    // console.log(`FOUND SLOT : ${JSON.stringify(slot)}`);
    // console.log(
    //   `startDate -> ${momentTz(parseInt(startDate)).tz(
    //     "Europe/Paris"
    //   )} slot (${JSON.stringify(slot)})`
    // );
    setSelectedSlot({
      startDate: momentTz(parseInt(startDate)).tz("Europe/Paris"),
      label: momentTz(parseInt(startDate))
        .tz("Europe/Paris")
        .format("ddd DD MMM YYYY HH:mm"),
      slot,
    });
  }

  const ContentPage = () => {
    const elts = Object.keys(optionsPerDays);
    const items = [];

    const onAmoChange = (e) => {
      // console.log(`SELECTED : ${JSON.stringify(e.target.value)}`);
      setSelectedAmo(e.target.value);
      // const isRightAmo = (element) => { element.amoNb ===}
      // console.log(`AMO NB SELECTED : ${JSON.stringify(amos.findIndex())}`);
      // setSelectedAmo(amos.find((x) => x.id === e.target.value));
    };

    for (const [idx, val] of elts.entries()) {
      items.push(
        <OptGroup
          key={idx}
          label={moment(optionsPerDays[val][0].startDate).format("ddd DD MMM")}
        >
          {optionsPerDays[val].map((day, idx2) => {
            return (
              <Option
                key={idx + "-" + idx2}
                value={JSON.stringify(day.startDate)}
              >
                {moment(day.startDate).format("HH:mm")}
              </Option>
            );
          })}
        </OptGroup>
      );
    }

    return (
      <div>
        {Object.keys(amos).length > 0 && planning.areAmosAssigned && (
          <div>
            <Card
              hoverable
              style={{
                width: 150,
                border: "none",
                maxHeight: "120px",
                maxWidth: "120px",
              }}
            >
              <img
                width="100%"
                height="100%"
                alt="avatar"
                src={
                  process.env.REACT_APP_API_URL +
                  "/users/" +
                  selectedAmo +
                  "/avatar"
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "data:image/png;base64,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";
                }}
              />
            </Card>
            <br />
          </div>
        )}
        {Object.keys(amos).length > 0 && planning.areAmosAssigned && (
          <Radio.Group
            buttonStyle="solid"
            onChange={onAmoChange}
            value={selectedAmo}
          >
            {amos.map((amo, idx) => (
              <Radio.Button
                key={idx}
                value={amo.id}
              >{`${amo.firstname} ${amo.lastname}`}</Radio.Button>
            ))}
          </Radio.Group>
        )}
        {/* <br />
        ok mobile
        <br /> */}
        <Select style={{ width: "100%" }} onChange={handleChange}>
          {items}
        </Select>
      </div>
    );
  };

  useEffect(() => {
    // console.log(`refreshPage(), selectedAmo : ${selectedAmo}`);
    let amoNb = planning.amoList.findIndex((e) => e === selectedAmo);
    // console.log(`Change sur AMO numero : ${amoNb}`);

    // console.log(
    //   `Planning.availabilities : ${JSON.stringify(planning.availabilities)}`
    // );
    const preOpts = JSON.parse(planning.availabilities)[
      (rdv.length / (planning.pas * 1000)).toString()
    ];

    // console.log(`preOpts :: ${JSON.stringify(preOpts)}`);
    const getSetDates = (opts) => {
      let starts = undefined;
      // if AMOs are assigned, let all starts and discrimine in BookingAvailabilities
      if (!planning.areAmosAssigned) {
        starts = Array.from(new Set(opts.map((x) => x.start)));
      } else {
        starts = opts.map((x) => x.start);
      }
      let newZouk = [];
      opts.forEach((x) => {
        if (starts.includes(x.start)) {
          let pplIdx = starts.indexOf(x.start);
          starts.splice(pplIdx, 1);
          // console.log(`starts.length => ${starts.length}`);
          newZouk.push(x);
        }
      });
      return newZouk;
    };
    // console.log(`end set option 1 `);
    // console.log(`preOpts -> ${JSON.stringify(preOpts)}`);
    const opts = getSetDates(preOpts); //JSON.parse(res.data.usrBooking.availabilities)[
    // console.log(`OPTS -> ${JSON.stringify(opts)}`);
    const optsPerDay = {};
    opts.forEach((opt) => {
      let k = moment(opt.start).format("DD-MM-YYYY");

      let obj = {
        startDate: opt.start,
        amoNb: opt.amoNb,
        label: momentTz(opt.start).tz("Europe/Paris").format("HH:mm"),
      };
      // console.log(opt.booked);
      // console.log(`end set option`);
      if (
        (opt.amoNb === amoNb && planning.areAmosAssigned) ||
        !planning.areAmosAssigned
      ) {
        if (Object.keys(optsPerDay).includes(k)) {
          optsPerDay[k].push(obj);
        } else {
          optsPerDay[k] = [obj];
        }
      }
      // console.log(`optsPerDay : ${JSON.stringify(optionsPerDays)}`);
    });

    // Sort options per day
    let optsPerDaySorted = {};
    for (let key in optsPerDay) {
      optsPerDaySorted[key] = optsPerDay[key].sort(function (a, b) {
        return a.startDate - b.startDate;
      });
    }

    setOptionsPerDays(optsPerDaySorted);
    setOptions(opts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAmo]);

  return (
    <div>
      <ContentPage />
    </div>
  );
};

export default BookingAvailabilitiesMobile;
